import * as React from 'react';
// @ts-ignore
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import ScheduledMaintenancePage from 'app/components/ScheduledMaintenancePage';
import LinkConstants from 'constants/LinkConstants';

import './styles/AdminUpgradePlanScheduledMaintenancePage.scss';

export default function AdminUpgradePlanScheduledMaintenancePage() {
  return (
    <div className="AdminUpgradeScheduledMaintenancePage">
      <AdminUpgradePageHeader
        title="Remind Hub for schools and districts"
        hideHelp
        hideClose
      />
      <ScheduledMaintenancePage
        className="AdminUpgradeScheduledMaintenancePage-content"
        subtext="Check back again soon. If you'd like to get in touch with our sales team now, feel free to reach out"
        contactUsRoute={LinkConstants.ADMIN_UPGRADE_FORM}
      />
    </div>
  );
}
